 /**
 * Connector Authentication Failure Reason
 */
export enum AuthFailureReason {
     /**
     * Default reason, when for any reason, popup window fails to retrieve connector auth info
     */
    Unknown = "Unknown"
}